import { Box, Typography } from "@mui/material";

interface Props {
  eyebrow: string;
  title: string;
  subtitle: string;
}

/**
 * Replica `.ph.ph-rule` del cotizador en el diseño: barra lateral de 2px en `primary.main`, eyebrow
 * en `primary.light`, título 28px/600 en el color de texto y párrafo gris.
 */
export const PageHeaderCotizador = ({ eyebrow, title, subtitle }: Props) => (
  <Box sx={{ mb: 4, borderLeft: "2px solid", borderColor: "primary.main", pl: "18px" }}>
    <Typography
      variant="body3"
      component="p"
      sx={{ fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "primary.light", mb: 1 }}
    >
      {eyebrow}
    </Typography>
    <Typography
      component="h1"
      sx={{
        // 28px del spec: queda entre `h3` (25) y `h2` (31) de la escala del theme.
        fontSize: 28,
        fontWeight: 600,
        letterSpacing: "-0.025em",
        lineHeight: 1.12,
        color: "text.primary",
        mb: 1.25,
      }}
    >
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55, maxWidth: 580 }}>
      {subtitle}
    </Typography>
  </Box>
);
